import axios from 'axios';
import { isPromise } from '@/scripts/validate';
import axiosCanceler from './axiosCancel';
import qs from 'qs';
import ContentTypeEnum from './contentType';

const getConfig = (baseConfig = {}, contentType) => {
  if (!contentType) return baseConfig || {};
  let headers = {};
  if (baseConfig.headers) {
    headers = { ...baseConfig.headers };
  }
  if (contentType) {
    headers['Content-Type'] = contentType;
  }
  return {
    ...baseConfig,
    headers,
  };
};

const requestInterceptors = (config) => {
  axiosCanceler.remove(config);
  axiosCanceler.add(config);

  if (config.headers && config.headers['Content-Type'] === ContentTypeEnum.FORM_URLENCODED) {
    if (config.data) {
      config.data = qs.stringify(config.data);
    }
  }

  // 统一注入 user_id / F_school_id（从 sessionStorage 获取）
  if (!config.params) {
    config.params = {};
  }
  if (!config.params.user_id && !config.params.F_user_id) {
    const userId = Object.keys(sessionStorage).find(k => k.endsWith('user_id'));
    if (userId) {
      config.params.user_id = sessionStorage.getItem(userId);
    }
  }
  if (!config.params.F_school_id) {
    const schoolId = Object.keys(sessionStorage).find(k => k.endsWith('school_id'));
    if (schoolId) {
      config.params.F_school_id = sessionStorage.getItem(schoolId);
    }
  }
  return config;
};

export class Http {
  //  instance;

  constructor(baseURL, baseContentType, { onRequest, onResponse }) {
    this.instance = axios.create({
      baseURL,
      headers: {
        'Content-Type': baseContentType,
      },
    });
    this.instance.interceptors.request.use(
      (config) => {
        if (onRequest) {
          const returnVal = onRequest(config);
          if (isPromise(returnVal)) {
            return returnVal.then((conf) => {
              return requestInterceptors(conf);
            });
          }
          return requestInterceptors(returnVal);
        }
        return requestInterceptors(config);
      },
      (error) => {
        axiosCanceler.clear();

        return Promise.reject(error);
      }
    );
    this.instance.interceptors.response.use(
      (response) => {
        axiosCanceler.remove(response.config);
        return onResponse ? onResponse(response) : response;
      },
      (error) => {
        axiosCanceler.remove(error.config || {});
        if (axios.isCancel(error)) {
          // 是取消请求的错误
          return Promise.reject({ ...error, isCancel: true });
        } else {
          return onResponse ? onResponse(error) : Promise.reject(error);
        }
      }
    );
  }
  get(url, query, config) {
    return this.instance.request({
      ...config,
      url,
      params: query,
      method: 'get',
    });
  }
  post(url, data, contentType, config) {
    return this.instance.request({
      ...getConfig(config, contentType),
      url,
      data,
      method: 'post',
    });
  }
  patch(url, data, contentType, config) {
    return this.instance.request({
      ...getConfig(config, contentType),
      url,
      data,
      method: 'patch',
    });
  }
  put(url, data, contentType, config) {
    return this.instance.request({
      ...getConfig(config, contentType),
      url,
      data,
      method: 'put',
    });
  }
  delete(url, query, contentType, config) {
    return this.instance.request({
      ...getConfig(config, contentType),
      url: url,
      params: query,
      method: 'delete',
    });
  }
}
